'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var BeachSoccer = function (_PureComponent) {
  (0, _inherits3.default)(BeachSoccer, _PureComponent);
  function BeachSoccer() {
    (0, _classCallCheck3.default)(this, BeachSoccer);
    return (0, _possibleConstructorReturn3.default)(this, (BeachSoccer.__proto__ || (0, _getPrototypeOf2.default)(BeachSoccer)).apply(this, arguments));
  }
  (0, _createClass3.default)(BeachSoccer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M13.312 26.88l1.6-.448-2.112-2.72L8.608 22.4 8 24.176a11.932 11.932 0 0 1-3.952-8.594c.57.682 1.212 1.288 1.922 1.805l2.685-3.18-.928-4.496a10.568 10.568 0 0 0-1.68-.13c-.225 0-.45.007-.67.02 1.602-2.916 4.26-5.074 7.45-5.95l-.476 2.348 4.37 1.36 3.375-2.032-1.872-1.92a12.04 12.04 0 0 1 7.97 5.344 6.572 6.572 0 0 0-1.31-.176l.428 4.496 2.77 2.288a11.863 11.863 0 0 1-1.965 6.445l-3.172 1.09-2.416 3.2c.09.085.19.164.295.235-1.366.606-2.968.955-4.65.955-.982 0-1.935-.118-2.846-.342zM16 1.6C8.49 1.6 2.4 7.69 2.4 15.2S8.49 28.8 16 28.8s13.6-6.09 13.6-13.6S23.51 1.6 16 1.6zm1.184 10.8l-3.648 3.104 1.888 4.592 4.8-.4 1.136-4.8zM32 28.8H0v1.6h32z'
      }));
    }
  }]);
  return BeachSoccer;
}(_react.PureComponent);
BeachSoccer.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = BeachSoccer;